import { useState, useEffect, useCallback } from 'react';
import httpService from '../../services/http.service';
import { useHistory } from 'react-router-dom';
import ErrorMessage from './errorMsg';

const useUserSubscription = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const history = useHistory()

    const getUserData = useCallback(async () => {
        const userId = localStorage.getItem("UserId");
        try {
            setLoading(true);
            if(!userId){
                return
            }
            const response = await httpService.get(`/get-user-details?userId=${userId}`);
            setUser(response.data.user);
        } catch (error) {
            ErrorMessage("Something went wrong");
        } finally {
            setLoading(false);
        }
    }, []);

    const getSubscriptionProgress = useCallback((startDateStr, endDateStr) => {
        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);
        const today = new Date();

        const totalTime = endDate - startDate;
        const timeUsed = today - startDate;
        const timeLeft = endDate - today;

        const totalDays = Math.ceil(totalTime / (1000 * 60 * 60 * 24));
        const daysLeft = Math.max(0, Math.ceil(timeLeft / (1000 * 60 * 60 * 24)));
        const percentUsed = Math.min(100, Math.max(0, Math.round((timeUsed / totalTime) * 100)));

        return {
            percentUsed,
            daysLeft,
            totalDays
        };
    }, []);

    const checkActiveStatus = useCallback(() => {
        if (!user?.startDate || !user?.endDate) return false;

        const { daysLeft } = getSubscriptionProgress(user.startDate, user.endDate);
        if (daysLeft === 0) {
            history.push('/uploadfile?source=renewal');
            return true;
        }
        return false;
    }, [user, getSubscriptionProgress, history]);

    useEffect(() => {
        getUserData();
    }, [getUserData]);

    return {
        user,
        loading,
        getUserData,
        getSubscriptionProgress,
        checkActiveStatus
    };
};

export default useUserSubscription;
